module.exports = __webpack_public_path__ + "img/cut_xianlai2.f507c52a.png";